import { render, staticRenderFns } from "./Puzzle.vue?vue&type=template&id=1bff9b1a&scoped=true&"
import script from "./Puzzle.vue?vue&type=script&lang=js&"
export * from "./Puzzle.vue?vue&type=script&lang=js&"
import style0 from "./Puzzle.vue?vue&type=style&index=0&id=1bff9b1a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bff9b1a",
  null
  
)

export default component.exports